import { useTheme } from '@mui/material/styles';
import { useCallback } from 'react';
import '../theme/customTheme.js';
import '../theme/defaultTheme.js';
import { getThemeColor } from '../theme/util.js';
import '../theme/componentNames.js';
import '../node_modules/tslib/tslib.es6.js';
import '../utils/stringUtils.js';
import '@mui/material';
import 'lodash';
import 'lodash/omitBy';
import 'lodash/isNil';

const useThemeColor = () => {
    const theme = useTheme();
    return useCallback((color) => {
        return getThemeColor(theme, color);
    }, [theme]);
};

export { useThemeColor };
//# sourceMappingURL=useThemeColor.js.map
